import { Link } from "wouter";
import { AlertCircle } from "lucide-react";
import { ColorfulLogo } from "@/components/ColorfulLogo";
import { Seo } from "@/lib/seo";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-4">
      <Seo
        title="Page Not Found | AgentsToGo"
        description="The page you are looking for doesn't exist or has been moved."
        path="/404"
        noindex
      />
      <Link href="/">
        <ColorfulLogo className="text-4xl mb-8 cursor-pointer" />
      </Link>
      <div className="max-w-md w-full bg-card rounded-2xl p-8 shadow-sm border border-border text-center">
        <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-6 text-destructive">
          <AlertCircle size={32} />
        </div>
        <h1 className="text-2xl font-bold mb-2">404 - Page Not Found</h1>
        <p className="text-muted-foreground mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link 
          href="/" 
          className="inline-flex items-center justify-center bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-6 py-3 rounded-lg transition-colors"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
